// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-test[data-v-5132a05c] {\n  padding-left: 0.48rem;\n  padding-right: 0.48rem;\n}\n", ""]);
// Exports
module.exports = exports;
